import React from "react";
import { List, Typography } from "antd";
import { Interview } from "../../../../Entities/Interview";
import { JobDescriptionEntity } from "../../../../Entities/JobDescription";
import { capitalizeFirstLetter } from "../../../../Utils/generic-functions";
import { avatarColors } from "../../../../Utils/theme-constants";

interface JobApplicationScheduledInterviewParticipantsProps {
  scheduledInterview: Interview;
  jobPost: JobDescriptionEntity;
}

const JobApplicationScheduledInterviewParticipants: React.FC<
  JobApplicationScheduledInterviewParticipantsProps
> = ({ scheduledInterview, jobPost }) => {
  const { participants, interviewGuests, user } = scheduledInterview;

  const totalParticipants =
    (participants?.length || 0) + 1 + (interviewGuests?.length || 0);

  const data = [
    {
      title: (
        <Typography.Text>
          {capitalizeFirstLetter(user.firstName)} &nbsp;
          {capitalizeFirstLetter(user.lastName)} &nbsp;
          <Typography.Text
            strong={false}
            type="secondary"
            style={{ fontSize: 12 }}
          >
            (Candidate)
          </Typography.Text>
        </Typography.Text>
      ),
      initials:
        user.firstName.charAt(0).toUpperCase() +
        user.lastName.charAt(0).toUpperCase(),
    },
  ];

  if (participants.length > 0) {
    const formattedList = participants.map((participant) => ({
      title: (
        <Typography.Text>
          {capitalizeFirstLetter(participant.name)} &nbsp;
          <Typography.Text
            strong={false}
            type="secondary"
            style={{ fontSize: 12 }}
          >
            (Organizer)
          </Typography.Text>
        </Typography.Text>
      ),
      initials: participant.name
        .split(" ")
        .map((name) => name.charAt(0).toUpperCase())
        .join(""),
    }));

    data.push(...formattedList);
  }

  if (interviewGuests && interviewGuests.length > 0) {
    const formattedList = interviewGuests.map((guest) => ({
      title: (
        <Typography.Text>
          {capitalizeFirstLetter(guest)} &nbsp;
          <Typography.Text
            strong={false}
            type="secondary"
            style={{ fontSize: 12 }}
          >
            (Guest)
          </Typography.Text>
        </Typography.Text>
      ),
      initials: guest.charAt(0).toUpperCase(),
    }));
    data.push(...formattedList);
  }

  return (
    <div className="job-application-scheduled-interview-section-container">
      <div className="job-application-scheduled-interview-section-header">
        <Typography.Title level={5} style={{ margin: 0 }}>
          Participants ({totalParticipants.toString()?.padStart(2, "0")})
        </Typography.Title>
      </div>

      <div className="job-application-scheduled-interview-participants-container">
        <List
          size="small"
          itemLayout="horizontal"
          dataSource={data}
          renderItem={(item, index) => (
            <List.Item key={index}>
              <List.Item.Meta
                avatar={
                  <span
                    className="job-application-scheduled-interview-participant-avatar"
                    style={{
                      backgroundColor:
                        avatarColors[item.initials.charAt(0).toUpperCase()],
                    }}
                  >
                    {item.initials}
                  </span>
                }
                title={item.title}
              />
            </List.Item>
          )}
        />
      </div>
    </div>
  );
};

export default JobApplicationScheduledInterviewParticipants;
